module.exports = __webpack_public_path__ + "img/top5_right.1965eb8a.png";